'use client';

import React, { useMemo } from 'react';
import SecondaryNavigation from 'layout/src/components/SecondaryNavigation';
import BackgroundWrapper from 'layout/src/components/SecondaryNavigation/_BackgroundWrapper';
import twMerge from 'utilities/src/twMerge';
import useWindowSize from 'ui/src/hooks/useWindowSize';
import useSearch from './_useSearch';
import SearchButton from './_SearchButton';
import SearchInput from '../SearchInput';
import GradientSearchCorner from './GradientSearchCorner';
import { headerButtonId } from '../Layout/Header';

interface Props {
  links: { label: string; href: string }[][];
}

export default function Navigation({ links }: Props) {
  const { navRef, openSearch, onBlur, onKeyDown, showSearch, isSearchInputFocused } = useSearch();
  const { isMdS } = useWindowSize({ mdS: 640 });
  const allLinks = useMemo(() => {
    if (isMdS) return links;
    return [
      [{ label: 'Blog', href: `${process.env.NEXT_PUBLIC_HOSTNAME}${process.env.NEXT_PUBLIC_BASE_PATH}` }],
      ...links,
    ];
  }, [links, isMdS]);
  return (
    <SecondaryNavigation
      headerButtonId={headerButtonId}
      links={allLinks}
      className={twMerge('mdL:mx-8 mdS:mx-6 lg:mx-auto lg:w-full lg:max-w-[76rem]', {
        'overflow-visible': isSearchInputFocused,
      })}
      linksListClassName="mdS:static"
      linksClassName={twMerge({ 'mdL:flex hidden': showSearch })}
      linksWrapperClassName={twMerge({
        'mdS:max-mdL:hidden hidden mdL:flex-initial mdL:rounded-r-none mdL:overflow-visible': showSearch,
      })}
      navRef={navRef}
      PrevListSibling={
        <BackgroundWrapper
          className={twMerge('mdL:pr-3 mdL:py-2.5 mdS:flex hidden items-center justify-between px-4 py-2', {
            'mdL:hidden': showSearch,
          })}
        >
          <SearchButton onClick={openSearch} />
        </BackgroundWrapper>
      }
      onBlur={onBlur}
    >
      <BackgroundWrapper
        className={twMerge(
          'mdL:flex-grow mdL:flex-shrink-0 mdL:min-w-[32.5rem] mdL:pl-2 mdL:pr-3 mdS:rounded-r-lg mdS:rounded-l-lg mdL:rounded-l-none relative z-10 flex px-4',
          {
            'mdS:hidden': !showSearch,
          },
        )}
      >
        <GradientSearchCorner />
        <SearchInput
          id="blog-search"
          classes="pb-0 pt-4 mdS:py-2.5 gap-2 !pl-0 [&_input]:placeholder:text-site-neutrals-400 flex-1"
          handleKeyDown={onKeyDown}
          buttonClasses="h-9 px-1.5 max-mdS:bg-site-neutrals-600"
          inputSize="Small"
        />
      </BackgroundWrapper>
    </SecondaryNavigation>
  );
}
